export default "The agent reviews a pull request and provides comments in accordance with the enterprise best guidelines.\n";